import inputTypes from "../../../../formComponents/formFields/constants";

const formFields = {
  email: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    required: true,
    label: "Email address",
  },
  action_type: {
    default: undefined,
    type: inputTypes.SELECT,
    required: true,
    label: "Action",
    options: [
      {
        label: "Account Info",
        value: "account_info",
      },
      {
        label: "Activation status",
        value: "activation_status",
      },
      {
        label: "Reactivate",
        value: "reactivate",
      },
      {
        label: "Deactivate",
        value: "deactivate",
      },
      {
        label: "Verify user",
        value: "verify",
      },
      {
        label: "Password reset URL",
        value: "password_url",
      },
      {
        label: "Verification URL",
        value: "verify_url",
      },
      {
        label: "Unsubscribe",
        value: "unsubscribe",
      },
      {
        label: "Remove throttle",
        value: "remove_throttle",
      },
      {
        label: "Apply throttle",
        value: "apply_throttle",
      },
      {
        label: "Remove copy/paste restriction",
        value: "remove_copy_paste_restriction",
      },
      {
        label: "Reset copy/paste restriction",
        value: "reset_copy_paste_restriction",
      },
      {
        label: "Remove contest cap restriction",
        value: "remove_contest_cap_restriction",
      },
      {
        label: "Reset contest cap restriction",
        value: "reset_contest_cap_restriction",
      },
      {
        label: "Apply survey silent treatment",
        value: "survey_silent_treatment",
      },
      {
        label: "Remove survey silent treatment",
        value: "remove_survey_silent_treatment",
      },
      {
        label: "Force user as a challenger",
        value: "force_challenger",
      },
      {
        label: "Correct email",
        value: "correct_email",
      },
      {
        label: "Redact solver account",
        value: "redact_solver_account",
      },
    ],
  },
  company_team_id: {
    default: undefined,
    type: inputTypes.SELECT,
    required: true,
    settings: {
      optionsFetchFrom: {
        url: "admin/contests/form_selects/challenge_teams",
        cacheKey: "adminFormSelectsChallengeTeams",
      },
    },
  },
  challenger_role: {
    default: undefined,
    type: inputTypes.SELECT,
    required: false,
    options: [
      { label: "Administrator", value: "administrator" },
      { label: "Reviewer", value: "reviewer" },
      { label: "Viewer", value: "viewer" },
    ],
    placeholder: "Select challenger role",
  },
  send_email: {
    default: "false",
    type: inputTypes.RADIO,
    name: "send_email",
    required: false,
    options: [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ],
  },
  correct_email: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    required: true,
    label: "New email",
  },
  trust_arc_id: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    name: "trust_arc_id",
    required: true,
    label: "TrustArc ID",
  },
};

const inputsConfigWithNames = Object.fromEntries(
  Object.entries(formFields).map(([fKey, fVal]) => [
    fKey,
    { name: fKey, ...fVal },
  ]),
);

export default inputsConfigWithNames;
